module.exports = __webpack_public_path__ + "./images/tournament-leaderboard-icon.334872e0496da6e62f35c145c30fa815.png";